<template>
  <ec-date-picker :value="dateRange" @update:value="onUpdateDateRange" type="daterange" :placeholder="placeholder" :editable="editable" />
</template>
<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
  defineProps<{
    from: number
    to: number
    placeholder?: string
    type: string
    editable?: boolean
  }>(),
  {
    type: "date",
    editable: false,
  }
)
const emits = defineEmits<{
  "update:from": [value: number]
  "update:to": [value: number]
}>()

const dateRange = computed(() => {
  if (!props.from || !props.to) {
    return null
  }
  if (props.from == 0 && props.to == 0) {
    return null
  }
  return [props.from, props.to]
})

const onUpdateDateRange = (value: any) => {
  emits("update:from", value[0])
  emits("update:to", value[1])
}
</script>
<style scoped></style>
